<script setup lang="ts">
import httpClient from '@/api/httpClient'
import ZezamIcon from '@/assets/icons/zezam.svg?component'
import { config } from '@/lib/helpers/config.helpers'
import { ref } from 'vue'

const props = defineProps<{
  userId: number
}>()

const isCreating = ref(false)

const attemptToLogin = async () => {
  try {
    const zezamData = await httpClient.get(`/users/${props.userId}/identity`)
    if (zezamData.data.zezam_user_id) {
      window.location.replace(`${config.zezamRedirectUrl}?as-user-id=${zezamData.data.zezam_user_id}`)
      return true
    }
  } catch (e) {
    console.log(e)
  }
  return false
}

const createOrLogin = async () => {
  const loginSuccessful = await attemptToLogin()

  if (loginSuccessful) {
    return
  }

  if (!confirm('This will create a blank zezam page for this user. Continue?')) {
    return
  }

  isCreating.value = true

  try {
    const zezamApiUrl = config.zezamApiUrl
    const response = await fetch(`${zezamApiUrl}/users/from-metapic`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        metapic_user_id: props.userId,
      }),
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }))
      throw new Error(errorData.detail || `HTTP ${response.status}`)
    }

    const result = await response.json()
    console.log('Created Zezam user:', result)

    await attemptToLogin()
  } catch (err) {
    console.error('Failed to create zezam user:', err)
    alert('Something went wrong creating the zezam user. Please contact support.')
    isCreating.value = false
  }
}
</script>
<template>
  <div class="zezam-login-btn__container">
    <button type="button" class="link zezam-login-btn__submit-btn" :disabled="isCreating" @click="createOrLogin">
      <zezam-icon />
      <span>zezam admin</span>
    </button>
  </div>
</template>
<style lang="scss" scoped>
.zezam-login-btn__container {
  margin: 0;
  padding: 0;
}
.zezam-login-btn__container .zezam-login-btn__submit-btn {
  margin-top: 0;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;

  span {
    margin-top: 0px;
    margin-left: 4px;
    margin-right: 4px;
    white-space: nowrap;
  }

  svg {
    width: 1.25em;
    height: 1.25em;
    display: inline-block;
    vertical-align: middle;
    pointer-events: none;
  }
}
</style>
